import { Component, OnDestroy, OnInit } from '@angular/core';
import { FloatPopupService } from 'app/services/float-popup.service';
import { AddressManageComponent } from '../address-manage.component';
import { Subscription } from 'rxjs';
import { MainDataService } from 'app/services/main-data.service';
import { ActivityService } from 'app/services/activity.service';
import { AttrIndexService } from 'app/services/attr-index.service';

@Component({
  selector: 'app-address-manage-tool',
  templateUrl: './address-manage-tool.component.html',
  styleUrls: ['./address-manage-tool.component.css']
})
export class AddressManageToolComponent implements OnInit, OnDestroy {

	// editable: boolean;
	// isAddress: boolean;

	// private editableSub: Subscription;
	// private selectedLayerSub: Subscription;
	constructor(
		private activityService: ActivityService,
		private attrIndexService: AttrIndexService,
		private floatPopupService: FloatPopupService,
		private mainDataService: MainDataService
	) { }

	clickBtn() {
		this.floatPopupService.openPopup(AddressManageComponent);
		this.activityService.selectedRecordsBS.next({
			ids: []
		})
	}
	ngOnInit() {
		// this.editableSub = this.mainDataService.dataEditableBS.subscribe(data => {
		// 	this.editable = data.editable;
		// });
		// this.selectedLayerSub = this.activityService.selectedLayerBS.subscribe(data => {
		// 	if (data && data.layer && data.layer.category.code === this.attrIndexService.cateCodeAddress) {
		// 		this.isAddress = true;
		// 	} else {
		// 		this.isAddress = false;
		// 	}
		// })
	}
	ngOnDestroy(): void {
		// this.editableSub.unsubscribe();
		// this.selectedLayerSub.unsubscribe();
	}
}
